
import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface NoQuestionsAvailableProps {
  skill: string;
  onComplete: () => void;
}

const NoQuestionsAvailable: React.FC<NoQuestionsAvailableProps> = ({ skill, onComplete }) => {
  return (
    <Card className="border border-[#0EA5E9]/20 shadow-md bg-white/80">
      <CardHeader>
        <CardTitle>{skill} Quiz</CardTitle>
        <CardDescription>
          No questions available for this skill yet. Please check back later.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center py-10 space-y-4">
        <Button 
          className="bg-[#0EA5E9] text-white hover:bg-[#0EA5E9]/90"
          onClick={onComplete}
        >
          Back to Dashboard
        </Button>
      </CardContent>
    </Card>
  );
};

export default NoQuestionsAvailable;
